import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import LogoImg from "assets/images/logo.svg";
import { HEADER_HEIGHT } from "constants/global";
import { UserContext } from "context/userContext";
import Navigation from "layout/MainLayout/components/Navigation";
import User from "layout/MainLayout/components/User";
import { useContext } from "react";

const Header = () => {
  const { me, meError, meLoading } = useContext(UserContext);
  const isAuth = !!me && !meError && !meLoading;

  return (
    <AppBar
      position='static'
      sx={{ height: HEADER_HEIGHT }}>
      <Container
        maxWidth='xl'
        sx={{ paddingX: { sm: 2 } }}>
        <Toolbar
          disableGutters
          sx={{
            alignItems: "center",
            overflow: "auto",
            scrollbarWidth: 0,
            p: 0,
            minHeight: `${HEADER_HEIGHT} !important`,
            "::-webkit-scrollbar": { display: "none" },
          }}>
          <Box
            src={LogoImg}
            component='img'
            alt='FoxtailBox Logo'
            sx={{ height: 40, width: 172, mr: 1 }}
          />
          <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", mr: 1 }}>
            <Navigation isAuth={isAuth} />
          </Box>
          {isAuth && <User />}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;
